import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    Row, Label, Input, Alert,
    FormGroup
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../estilos.css';
import * as xlsx from "xlsx";
import * as IoIcons from 'react-icons/io';
import Moment, { updateLocale } from 'moment';
import QrReader from "react-qr-reader";
import BarcodeReader from 'react-barcode-reader';
import { GetPProduccionGeneral, GetPProduccionGeneralID, GetRecibaSerialesMP, GetUsuarios } from '../queries/Queries';
import { ObtenerSerialesPProduccionPC, datosRSerial, decodificarTextoJSON } from '../queries/DCUbicaciones';
import DetallesProduccion from '../produccion/DetallesProduccion';
import Inspeccion from './Inspeccion';
import GeneralProduccion from '../produccion/GeneralProduccion';

const initialfFormState = { formType: 'Producción' }


function InspeccionPC() {
    //Declaración de variables            
    const [pProduccionPEyP, setPProduccionPEyP] = useState([]);
    const [pProduccionPEyPSinfiltro, setPProduccionPEyPSinfiltro] = useState([]);
    const [pInspeccion, setPInspeccion] = useState([]);
    const [racksVigentes, setRacksVigentes] = useState([]);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const [idProduccionGeneral, setIDProduccionGeneral] = useState("");
    const userName = window.$name;
    const ppproduccion = window.$ProduccionCalidad ? window.$ProduccionCalidad : false;
    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [nombreUsuario, setNombreUsuario] = useState("");
    const [aVisible, setAVisible] = useState(false);
    const [registroIndividual, setRegistroIndividual] = useState(true);
    const [pHabilitado, setHabilitado] = useState(true);
    const [sumProduccionp, setSumProduccionp] = useState("");
    const onDismiss = () => setAVisible(false);
    const [inspeccionar, seInspeccionar] = useState(false);
    const [datosReciba, SetDatosReciba] = useState(false);
    const [pInspeccionUnica, setPInspeccionUnica] = useState(false);
    const [textBInspeccion, setTextBInspecicon] = useState("Registrar inspección");
    const [inspeccionCompleta, setInspeccionCompleta] = useState(false);
    const [filtroVer, setFiltroVer] = useState("Todo");
    const [pCSerialBTI, setPCSerialBTI] = useState("");
    Moment.locale('en');
    var now = new Date();

    function handleError(err) {
        console.error(err)
    };
    function handleScan(data) {
        //data = data.replace('\'', '-')
        if (data) {
            scanner(data)
        }
        //return <p>{data}</p>
    };

    async function scanner(data) {
        //data = data.replace('\'', '-')
        setCargando(true);
        if (data) {
            const serialID = data.replaceAll("'", "-");
            const datosProduccion = await datosRSerial(serialID);
            const datoE = serialID.substr(0, 2).toLowerCase() === "3s" ? serialID.substr(2, serialID.length) : serialID;
            /*setMensajeAlert(JSON.stringify(datosProduccion));
            setColor("warning");
            setCargando(false);
            setAVisible(true);*/
            setPCSerialBTI(datoE);
            //const datosProduccion = pProduccion.filter((planProduccion) => (planProduccion.recibaSerialID === serialID) || (planProduccion.serialRecibaBTI === serialID.toUpperCase()) || (planProduccion.serial === serialID.toUpperCase()) || (planProduccion.serial === datoE.toUpperCase()));
            if (datosProduccion.length > 0) {
                setPInspeccion(() => ({ ...datosProduccion[0], ["piezasEnRecuperando"]: "" }));
                if ((((datosProduccion[0].piezasCalidadPC ? datosProduccion[0].piezasCalidadPC : 0) +
                    (datosProduccion[0].piezasNoAceptadasPC ? datosProduccion[0].piezasNoAceptadasPC : 0)) ===
                    (datosProduccion[0].cantidadPlaneadaPC ? datosProduccion[0].cantidadPlaneadaPC : 0)) || (
                        (datosProduccion[0].piezasenPintadoPC ? datosProduccion[0].piezasenPintadoPC : 0) <
                        (datosProduccion[0].cantidadPlaneadaPC ? datosProduccion[0].cantidadPlaneadaPC : 0)
                    )) {
                    /* window.scrollTo(0, 0);
                     setMensajeAlert("No fue posible realizar la operación: el material ya fue inspeccionado.");
                     setColor("warning");
                     setCargando(false);
                     setAVisible(true);*/
                    SetDatosReciba(true);
                } else {
                    setTextBInspecicon("Registrar inspección");
                    //setPInspeccion(() => ({ ...datosProduccion[0], ["piezasEnRecuperando"]: "" }));
                    seInspeccionar(true);
                    setPCSerialBTI("");
                }
            } else {
                //setTextBCarga("Carga");
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: el código QR no coincide con ningún número de serie disponible para la inspección de calidad, favor de buscar el material que corresponda y volver a intentarlo");
                setColor("warning");
                setCargando(false);
                setAVisible(true);

            }
        }
        //return <p>{data}</p>
        setCargando(false);
    };

    //Método useEffect
    useEffect(() => {
        fetchUsuario();
    }, []);

    //Obtiene el nombre de usuario del usuario logueado
    async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            usuario: {
                eq: userName
            }
        }
        //Se obtienen los datos del usuario
        const apiData = await GetUsuarios(filter);

        //Se filtran los datos por orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setNombreUsuario(dataFromAPI[0].nombreCompleto);
        setPInspeccionUnica(dataFromAPI[0].InspeccionUnicaCalidad ? dataFromAPI[0].InspeccionUnicaCalidad : false);
        fetchPProduccionGeneral(Moment(now).format("YYYY-MM-DD"));
    }
    async function fetchPProduccionGeneral(fecha) {
        setCargando(true);
        let filter = {
            and: [
                {
                    activo: {
                        eq: true,
                    },
                },
                {
                    fechaDePlaneacion: {
                        eq: fecha,
                    },
                },
            ],
        };
        //setNumeroPProduccion(numero);
        const PProduccionGeneral = await GetPProduccionGeneral(filter);
        if (PProduccionGeneral.length > 0) {
            setIDProduccionGeneral(PProduccionGeneral[0].id);
            await fetchPlanProduccionPEyP(PProduccionGeneral[0].id, filtroVer);
        } else {
            await fetchPlanProduccionPEyP("", filtroVer);
            setIDProduccionGeneral("");
            setCargando(false);
        }
    }

    //Obtiene los datos guardados de los planes de producción para etiquetado y pintado
    async function fetchPlanProduccionPEyP(pproduccionG, filtroVerb) {
        //Filtro por planeación activa
        setCargando(true);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            }
            ]
        }


        //Se obtienen los datos del plan de producción
        const apiData = await GetRecibaSerialesMP(filter);
        const pproduccionGR = pproduccionG != "" ? await GetPProduccionGeneralID(pproduccionG) : {};
        const serialesPPG = pproduccionGR.id ? await ObtenerSerialesPProduccionPC(pproduccionGR, apiData) : apiData;
        var racksA = [];
        //setPProduccionPEyP(serialesPPG);
        if (serialesPPG.length > 0) {
            //Filtrado de datos
            const pProduccionFromAPI = serialesPPG.filter(pproduccion =>
            ((pproduccion.piezasenPintadoPC ? pproduccion.piezasenPintadoPC : 0) > 0 &&
                (((parseInt(pproduccion.piezasCalidadPC ? pproduccion.piezasCalidadPC : 0) +
                    (parseInt(pproduccion.piezasNoAceptadasPC ? pproduccion.piezasNoAceptadasPC : 0))) <
                    (pproduccion.cantidadPlaneadaPC ? pproduccion.cantidadPlaneadaPC : 0)) ||
                    (((parseInt(pproduccion.piezasCalidadPC ? pproduccion.piezasCalidadPC : 0) +
                        (parseInt(pproduccion.piezasNoAceptadasPC ? pproduccion.piezasNoAceptadasPC : 0))) ===
                        (pproduccion.cantidadPlaneadaPC ? pproduccion.cantidadPlaneadaPC : 0)) &&
                        ((pproduccion.calidadFechaHoraPC ? pproduccion.calidadFechaHoraPC : "").includes(Moment(new Date()).format("YYYY-MM-DD")) ||
                            (pproduccion.noAceptadasFechaHoraPC ? pproduccion.noAceptadasFechaHoraPC : "").includes(Moment(new Date()).format("YYYY-MM-DD"))
                        ))))).sort((a, b) =>
                            (a.cliente + a.numerodeParte + a.serial) > (b.cliente + b.numerodeParte + b.serial) ? 1 :
                                (a.cliente + a.numerodeParte + a.serial) < (b.cliente + b.numerodeParte + b.serial) ? -1 : 0);
            await Promise.all(pProduccionFromAPI.map(async (pproduccion, i) => {


                //if (unicaInspeccion === true) {
                const piezasTotales = (parseInt(pproduccion.piezasInspeccionPC ? pproduccion.piezasInspeccionPC : 0)) +
                    (parseInt(pproduccion.piezasEnInspeccionando ? pproduccion.piezasEnInspeccionando : 0)) +
                    (parseInt(pproduccion.piezasCalidadPC ? pproduccion.piezasCalidadPC : 0) +
                        (parseInt(pproduccion.piezasNoAceptadasPC ? pproduccion.piezasNoAceptadasPC : 0)));

                pproduccion.piezasEnInspeccionando = (parseInt(pproduccion.piezasenPintadoPC) - piezasTotales) < 0 ? 0 :
                    (parseInt(pproduccion.piezasenPintadoPC) - piezasTotales);

                pproduccion.piezasDisponibles = pproduccion.piezasEnInspeccionando;

                if (pproduccion.registroCargaPC) {
                    const datosDesgloce = await decodificarTextoJSON(pproduccion.registroCargaPC);
                    await Promise.all(datosDesgloce.map(async (x) => {
                        if (x.numeroRackCarga) {
                            const racksg = racksA.filter(r => r.rack === x.numeroRackCarga)
                            if (!racksg[0]) {
                                racksA.push({
                                    rack: x.numeroRackCarga, serialRecibaBTI: pproduccion.serialRecibaBTI,
                                    numerodeParte: pproduccion.numerodeParte
                                });
                            }
                        }
                    }))
                }
                return pproduccion;
            }))
            setPProduccionPEyP([]);
            setPProduccionPEyPSinfiltro(pProduccionFromAPI);
            busquedaPProduccion(pProduccionFromAPI, filtroVerb);
            setRacksVigentes(racksA.sort((a, b) => a.rack > b.rack ? 1 : a.rack < b.rack ? -1 : 0));
        } else {
            setPProduccionPEyP([]);
        }
        setCargando(false);

    }


    //busqueda con el filtro ver Todo, No cargados, No pintados, No atrasados, Cargados, Pintados, Atrasados
    async function busquedaPProduccion(pproduccionsf, verBusqueda, fecha) {
        pproduccionsf = pproduccionsf.filter(pproduccion => verBusqueda ?
            verBusqueda === "Piezas Inspeccionadas" ? ((!pproduccion.piezasCalidadPC ? 0 : pproduccion.piezasCalidadPC) +
                (!pproduccion.piezasNoAceptadasPC ? 0 : pproduccion.piezasNoAceptadasPC)) > 0 :
                verBusqueda === "Piezas aceptadas" ? (!pproduccion.piezasCalidadPC ? 0 : pproduccion.piezasCalidadPC) > 0 :
                    verBusqueda === "Piezas no aceptadas" ? (!pproduccion.piezasNoAceptadasPC ? 0 : pproduccion.piezasNoAceptadasPC) > 0 :
                        verBusqueda === "Piezas no Inspeccionadas" ? ((!pproduccion.piezasCalidadPC ? 0 : pproduccion.piezasCalidadPC) +
                            (!pproduccion.piezasNoAceptadasPC ? 0 : pproduccion.piezasNoAceptadasPC)) == 0 :
                            verBusqueda === "Fecha" ? (pproduccion.cargaFechaHoraPC ? pproduccion.cargaFechaHoraPC.includes(fecha) : pproduccion.id === "") > 0 :
                                verBusqueda === "NSB" ? pCSerialBTI === "" ? pproduccion.id === pproduccion.id :
                                    (pproduccion.serial.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                                        pproduccion.serialRecibaBTI.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                                        pproduccion.numerodeParte.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                                        pproduccion.lote.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                                        pproduccion.po.toLowerCase().includes(pCSerialBTI.toLowerCase())
                                    ) :
                                    pproduccion.id === pproduccion.id //Todo
            : pproduccion.id === pproduccion.id)

        setPProduccionPEyP(pproduccionsf);
    }
    //Búsqueda en plan de producción
    function onChangeVer(e) {
        setFiltroVer(e.target.value);
        busquedaPProduccion(pProduccionPEyPSinfiltro, e.target.value);
    }
    //Búsqueda serial en el plan de producción
    function bucarNSB(e) {

        setFiltroVer("NSB");
        /*const datoBusqueda = pProduccionPEyPSinfiltro.filter(pproduccion => pCSerialBTI === "" ?
            pproduccion.id === pproduccion.id :
            (pproduccion.serial.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                pproduccion.serialRecibaBTI.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                pproduccion.numerodeParte.toLowerCase().includes(pCSerialBTI.toLowerCase())));
        if (datoBusqueda.length > 0) {
            setPProduccionPEyP(datoBusqueda);
        } else {*/
        fetchPlanProduccionPEyP(idProduccionGeneral, "NSB");
        //}
    }

    //Búsqueda serial en el plan de producción
    function onChangeIS(e) {
        setPCSerialBTI(e.target.value);
        if (filtroVer === "NSB" && e.target.value === "") {
            setFiltroVer("Todo");
            fetchPlanProduccionPEyP(idProduccionGeneral, "Todo");
        }

    }
    function clicBuscarporFecha(e) {
        setAVisible(false);
        setFechaPBusqueda("");
        setBuscarporFecha(!buscarporFecha);
        setFiltroVer("Todo");
        if (!buscarporFecha === false) {
            if (fechaPBusqueda !== "") {
                fetchPlanProduccionPEyP(idProduccionGeneral, "Todo");
            }
        }
    };

    function onSearchFechaCarga(e) {
        setAVisible(false);
        setFechaPBusqueda(e.target.value);
        busquedaPProduccion(pProduccionPEyPSinfiltro, "Fecha", e.target.value);
    };
    async function aceptarInspeccion(result) {
        setAVisible(false);
        setCargando(true);
        setGuardando(true);
        if (result.mensaje) {
            setMensajeAlert(result.mensaje);
            setColor(result.color);
            window.scrollTo(0, 0);
            setAVisible(true);
        }
        seInspeccionar(false);
        SetDatosReciba(false);
        setCargando(false);
        setGuardando(false);
        if (result.completo === true) {
            setIDProduccionGeneral(result.pproduccionGID);
            fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
        }
    };
    function clicInspeccionar() {
        setRegistroIndividual(false);
        if (textBInspeccion === "Registrar inspección") {
            setTextBInspecicon("Terminar inspección");
            setInspeccionCompleta(false);
            // moveralSiguiente();
        } else {
            setTextBInspecicon("Registrar inspección");
            //fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
        }

    };


    async function clicDescargarDatos() {
        setCargando(true);
        setAVisible(false);
        //Declaración de variables
        var almacenEXP = [];
        var pPPEyP = pProduccionPEyP;
        //Se obtienen los datos 
        //No.	Cliente	Número de parte	Descripción	Serial	Serial BTI	
        //Racks	Fecha de carga	Piezas en pintado	Piezas Pintadas	
        //Piezas en Recuperación	Piezas aceptadas	Piezas no aceptadas
        await Promise.all(
            pPPEyP.map((pProduccion, i) => {

                //Se agregan los datos de la reciba
                almacenEXP.push({
                    "NO.": i + 1,
                    CLIENTE: pProduccion.cliente,
                    //HORA: Moment(pProduccion.fechayHoraDeReciba).format("HH:mm"),
                    "NÚMERO DE PARTE": pProduccion.numerodeParte,
                    "DESCRIPCIÓN": pProduccion.descripcion,
                    SERIAL: pProduccion.serial,
                    "SERIAL BTI": pProduccion.serialRecibaBTI,
                    RACKS: pProduccion.racks,
                    "FECHA DE CARGA": pProduccion.cargaFechaHoraPC,
                    "PIEZAS EN PINTADO": pProduccion.piezasenPintadoPC > 0 ?
                        pProduccion.piezasenPintadoPC : "",
                    "PIEZAS ACEPTADAS": pProduccion.piezasCalidadPC,
                    "PIEZAS NO ACEPTADAS": pProduccion.piezasNoAceptadasPC,
                });

                //


                //return reciba
            })
        );

        var worksheet = xlsx.utils.json_to_sheet(almacenEXP);
        var workbook = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(workbook, worksheet, filtroVer);
        xlsx.writeFile(
            workbook,
            "Inspección final " + filtroVer + " " + Moment(new Date()).format("DD-MM-YYYY") + "  " + Moment(new Date()).format("HH:mm") + ".xlsx"
        );
        setCargando(false);
    }

    return (
        <>
            {ppproduccion === true && (
                <>
                    <Fragment>

                        <Row>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                {pProduccionPEyP.length > 0 && (
                                    <h5 className=" floatleft">Plan de producción del {Moment(pProduccionPEyP[0].fechaDePlaneacion).format("DD/MM/YYYY")}</h5>
                                )}
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px text"  >
                                {textBInspeccion === "Terminar inspección" && (
                                    <>
                                        {guardando === false && (
                                            <QrReader
                                                delay={300}
                                                onError={handleError}
                                                onScan={handleScan}
                                                className="qrReader"
                                            />
                                        )}
                                        {/*<Label className="floatleft"><input type="checkbox" name="CBCC" checked={inspeccionCompleta} onChange={(e) => setInspeccionCompleta(e.target.checked)} className='ml-2' />Inspección completa</Label>*/}
                                    </>
                                )}
                                {guardando === false && (
                                    <BarcodeReader
                                        onError={handleError}
                                        onScan={handleScan}
                                        minLength={1}
                                    />
                                )}
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <button className="cbutton btn-dark floatright  ml-2 " title="Recargar página" onClick={() => { fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                <button className="cbutton  floatright  ml-2 btn-primary" title="Registrar inspección" hidden={pProduccionPEyP.length ? false : true} onClick={() => { clicInspeccionar(); }}>{textBInspeccion}</button>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 margintop20px">
                            </div>
                        </Row>
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                                    {mensajeAlert}
                                </Alert>
                            </div>
                            {cargando === true && (
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            )}
                        </Row>

                        <Row className={"mr-5fi margintop20px"}>
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12  " ></div>
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12  " >
                                <div class="input-group ">
                                    <Input name="area"
                                        value={pCSerialBTI}
                                        onChange={(e) => onChangeIS(e)}
                                        placeholder="Búsqueda por: Número de parte/Serial/Serial BTI/Lote/PO"
                                    />
                                    <div class="input-group-prepend">
                                        <button class="cbuttonS floatleft btn-primary" title="Buscar por número de parte, serial, serial BTI, Lote o PO" onClick={e => bucarNSB(e)}> <IoIcons.IoMdSearch /> </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 " >
                                <FormGroup >
                                    <Label className={"floatrightleft margintop-40pxMobil"}><h5>Búsqueda por fecha: </h5></Label>

                                    <div class="input-group ">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text ">
                                                <input type="checkbox" checked={buscarporFecha} onChange={clicBuscarporFecha} />
                                            </div>
                                        </div>
                                        <input type="date" class="form-control" onChange={onSearchFechaCarga} value={fechaPBusqueda} disabled={!buscarporFecha} />
                                    </div>
                                </FormGroup>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-left  ">
                                <button
                                    class="btn-warning cbutton ml-5"
                                    title="Descargar datos a excel"
                                    onClick={() => clicDescargarDatos("descarga")}

                                >
                                    <IoIcons.IoIosDownload /> Descargar datos
                                </button>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-11 col-xs-11   ">
                                <div class="input-group ">
                                    <div class="input-group-prepend">
                                        <Label className="floatrightleft mr-1">
                                            Ver:
                                        </Label>
                                    </div>
                                    <select
                                        name="filtro"
                                        className=" custom-select floatrightleft  "
                                        onChange={e => onChangeVer(e)}
                                    >
                                        <option value="Todo" selected={filtroVer == "Todo" ? true : false}>
                                            Todo
                                        </option>
                                        <option value="Piezas aceptadas" selected={filtroVer == "Piezas aceptadas" ? true : false}>
                                            Piezas aceptadas
                                        </option>
                                        <option value="Piezas no aceptadas" selected={filtroVer == "Piezas no aceptadas" ? true : false}>
                                            Piezas no aceptadas
                                        </option>
                                        <option value="Piezas en recuperación" selected={filtroVer == "Piezas en recuperación" ? true : false}>
                                            Piezas en recuperación
                                        </option>
                                        <option value="Piezas Inspeccionadas" selected={filtroVer == "Piezas Inspeccionadas" ? true : false}>
                                            Piezas Inspeccionadas
                                        </option>
                                        <option value="Piezas no Inspeccionadas" selected={filtroVer == "Piezas no Inspeccionadas" ? true : false}>
                                            Piezas no Inspeccionadas
                                        </option>
                                    </select>
                                </div>

                            </div>
                        </Row>
                        {inspeccionar === true && (
                            <Inspeccion
                                sProduccion={pInspeccion}
                                bColor={"cbutton btn-primary  ml-1"}
                                btitle={"Registrar inspección"}
                                modulo={"Calidad-P"}
                                usuario={userName}
                                operacion={"scan"}
                                valorDeREtorno={aceptarInspeccion}
                                proceso={"PowderCoat"}
                                racksCarga={racksVigentes}
                            />
                        )}
                        {datosReciba === true && (
                            <GeneralProduccion
                                sProduccion={pInspeccion}
                                bColor={"warning mr-2"}
                                btitle={"Embarcar Material"}
                                modulo={"Calidad-P"}
                                usuario={userName}
                                modalO={true}
                                valorDeREtorno={aceptarInspeccion}
                                proceso={"PowderCoat"}
                            />
                        )}
                        {pProduccionPEyP.length > 0 && (
                            <>
                                <div >
                                    <div className={pProduccionPEyP.length > 8 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                                        " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                                        <Table className=" mb-2 " >
                                            <Thead class="thead-secondary">
                                                <Tr>
                                                    <Th>No.</Th>
                                                    <Th className="minwidth200px">Cliente</Th>
                                                    <Th className="minwidth100px">Número de parte</Th>
                                                    <Th className="minwidth100px">Descripción</Th>
                                                    <Th>Serial</Th>
                                                    <Th className="minwidth100px">Serial BTI</Th>
                                                    <Th>Lote</Th>
                                                    <Th>PO</Th>
                                                    <Th className={"minwidth100px"}>Cantidad recibida</Th>
                                                    <Th className={"minwidth100px"}>Cantidad planeada</Th>
                                                    <Th className="minwidth100px">Fecha de carga</Th>
                                                    <Th className="minwidth60p ">Piezas aceptadas</Th>
                                                    <Th className="minwidth100p ">Piezas no aceptadas</Th>
                                                    <Th className="minwidth80px ">Acciones</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {pProduccionPEyP.map((pProduccion, i) => (
                                                    <Tr class={(i % 2) !== 0 ? "table-active" : ""}>
                                                        <Td>{i + 1}</Td>
                                                        <Td>{pProduccion.cliente}</Td>
                                                        <Td>{pProduccion.numerodeParte}</Td>
                                                        <Td >{pProduccion.descripcion}</Td>
                                                        <Td className={pProduccion.descripcion ? "" : "margintopmobil20px"}>{pProduccion.serial}</Td>
                                                        <Td >{pProduccion.serialRecibaBTI}</Td>
                                                        <Td >{pProduccion.lote}</Td>
                                                        <Td >{pProduccion.po}</Td>
                                                        <Td >
                                                            {pProduccion.cantidadRecibida
                                                                ? pProduccion.cantidadRecibida
                                                                : "--"}
                                                        </Td>
                                                        <Td >
                                                            {pProduccion.cantidadPlaneadaPC
                                                                ? pProduccion.cantidadPlaneadaPC
                                                                : "--"}
                                                        </Td>
                                                        <Td >{pProduccion.cargaFechaHoraPC}</Td>
                                                        <Td className="margintopmobil20px">{pProduccion.piezasCalidadPC}</Td>
                                                        <Td>{pProduccion.piezasNoAceptadasPC} </Td>
                                                        <Td className="margintopmobil40px">
                                                            <div className='mt-1 ml-1'>
                                                                <DetallesProduccion
                                                                    sProduccion={pProduccion}
                                                                    tipo={"todo"}
                                                                    bColor={"info floatrightleft"}
                                                                    btitle={"Detalle de producción"}
                                                                />
                                                                {/* <button className="cbutton btn-primary  ml-1 " title="Registrar inspección" onClick={() => { clicInspeccion(pProduccion); }} ><IoIcons.IoMdSearch /></button>}*/}
                                                                <Inspeccion
                                                                    sProduccion={pProduccion}
                                                                    bColor={"cbutton btn-primary  ml-1"}
                                                                    btitle={"Registrar inspección"}
                                                                    modulo={"Calidad"}
                                                                    usuario={userName}
                                                                    operacion={"individual"}
                                                                    valorDeREtorno={aceptarInspeccion}
                                                                    proceso={"PowderCoat"}
                                                                    racksCarga={racksVigentes}
                                                                />
                                                            </div>
                                                        </Td>
                                                    </Tr>

                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                        <h5 class="floatcenter">{sumProduccionp}</h5>
                                    </div>
                                </div>
                            </>
                        )}
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pProduccionPEyP)}</div>*/}
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(Moment(now).format("YYY-MM-DD"))}</div>*/}
                    </Fragment>

                </>
            )}
        </>
    )
};



export default InspeccionPC;
